export const CONSTANTS = { MAX_CHILD_ACCOUNTS: 9 };

export default CONSTANTS